import Vue from 'vue'
import LazyDom from '@/components/lazy-dom'

import VInput from '@/components/control/v-input'
import VSelect from '@/components/control/v-select'
import VInputSelect from '@/components/control/v-input-select'
import VInputNumber from '@/components/control/v-input-number'
import VDatetimePicker from '@/components/control/v-datetime-picker'
import VDatePicker from '@/components/control/v-date-picker'
import VCheckboxGroup from '@/components/control/v-checkbox-group'
import VCheckboxGroupExtra from '@/components/control/v-checkbox-etra'
import VPagination from '@/components/control/v-pagination'
import VRadioGroup from '@/components/control/v-radio-group'
import VAudio from '@/components/control/v-audio'
import VDialog from '@/components/control/v-dialog'
import VSwitch from '@/components/control/v-switch'
import VButton from '@/components/control/v-button'
import VUpload from '@/components/control/v-upload'
import VCheckbox from '@/components/control/v-checkbox'
import VAutocomplete from '@/components/control/v-autocomplete'
import VCascader from '@/components/control/v-cascader'

import VQuillEditor from '@/components/control/v-quill-editor'

import FileContainer from '@/views/components/file-container'
import VInputRange from '@/components/control/v-input-range'

import ConfirmBox from '@/components/confirm_box/main'
import MessageBox from '@/components/message_box/main'
import NewMessageBox from '@/components/new_message_box/main'
import NewMessageDialog from '@/components/new_message_dialog/main'

import VPdf from '@/components/control/v-pdf'
import VRowCol from '@/components/control/v-row-col'
import dialogComponent from '@/components/dialogComponent'

import VEditor from '@/components/control/v-editor'
import VInputTags from '@/components/control/v-input-tag'

import toTop from '@/components/control/to-top'
import EmailTooltip from '@/views/components/email-tooltip'
import VBirthDay from '@/components/control/v-birth-day'
import AltCopy from '@/components/control/alt-copy'
import VPopup from '@/components/v-popup'

import VWaring from '@/components/control/v-warning'
import SelectGroupList from '@/components/control/select-group-list'
import VTextSwitch from '@/components/control/v-text-switch'
import VServicedProgress from '@/components/control/v-serviced-progress'
import VNewDialog from '@/components/control/v-new-dialog'

Vue.prototype.$ConfirmBox = ConfirmBox.install
Vue.prototype.$MessageBox = MessageBox.install
Vue.prototype.$NewMessageBox = NewMessageBox.install
Vue.prototype.$NewMessageDialog = NewMessageDialog.install

Vue.component('lazy-dom', LazyDom)


Vue.component('v-input', VInput)
Vue.component('v-select', VSelect)
Vue.component('v-input-number', VInputNumber)
Vue.component('v-datetime-picker', VDatetimePicker)
Vue.component('v-date-picker', VDatePicker)
Vue.component('v-checkbox-group', VCheckboxGroup)
Vue.component('v-checkbox-extra', VCheckboxGroupExtra)
Vue.component('v-pagination', VPagination)
Vue.component('v-radio-group', VRadioGroup)
Vue.component('v-audio', VAudio)
Vue.component('v-dialog', VDialog)
Vue.component('v-switch', VSwitch)
Vue.component('v-button', VButton)
Vue.component('v-upload', VUpload)
Vue.component('v-checkbox', VCheckbox)
Vue.component('v-autocomplete', VAutocomplete)
Vue.component('v-cascader', VCascader)
Vue.component('v-input-tags', VInputTags)

Vue.component('v-pdf', VPdf)

Vue.component('v-quill-editor', VQuillEditor)
Vue.component('file-container', FileContainer)
Vue.component('v-input-range', VInputRange)
Vue.component('v-input-select', VInputSelect)
Vue.component('v-row-col', VRowCol)

Vue.component('v-editor', VEditor)
Vue.component('dialogComponent', dialogComponent)
Vue.component('to-top', toTop)
Vue.component('email-tooltip', EmailTooltip)
Vue.component('v-birth-day', VBirthDay)
Vue.component('alt-copy', AltCopy)
Vue.component('v-popup', VPopup)
Vue.component('v-select-list', SelectGroupList)
Vue.component('v-warning', VWaring)
Vue.component('v-select-list', SelectGroupList)
Vue.component('v-text-switch', VTextSwitch)
Vue.component('v-serviced-progress', VServicedProgress)
Vue.component('v-new-dialog', VNewDialog)
